/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik, Field } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import { differenceInCalendarDays, isAfter } from 'date-fns';
import Layout from 'components/Layout';
import Colors from 'constants/Colors';
import { ButtonContent, IconButton, PartnerSignatureLabel, QualificationContainer } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import StepNavigation from 'components/StepNavigation';
import BrokingSummary from 'components/BrokingSummary';
import {
	Button,
	ButtonContainer,
	LostCancelButton,
	FormContainer,
	FormSectionGlobal as FormSection,
	Clauses,
	ResponsiveTable,
	FileModal,
	NotesAccordion,
	HasPermission,
	Icon
} from '@fitinsur/components'

import { Content, RefreshButon } from './styles';
import * as yup from 'yup';
import { CheckBox, Label } from "@fitinsur/components";
import { useGetDocumentsAsync } from '@fitinsur/services/DocumentsService';
import {
	LoaderContext
} from '@fitinsur/contexts'
import { useGetOperationAsync, useResetOperationState, useUpdateOperationSync } from 'services/OperationService';
import {
	useGetQuestionnaireAnswer,
	useSaveQuestionnaireAnswer,
	useGetQuestionnaireAnswerAsync,
	useDeleteQuestionnaireAnswerAsync,
	useGetPetCadinStatusAsync,
	useGetSerasaStatusAsync,
	useGetSerasaStatusPartnerAsync,
	useGetDefaultingStatusAsync
} from '@fitinsur/services/QuestionnaireAnswerService';
import {
	useUpdateDocumentsClausesSync
} from 'services/ClausesService';
import { onValidationError } from 'containers/edit/handleQuestionChange';
import {
	handleQuestionsInitialAdjustments,
	handleClauseQuestionChange,
	handleQuestionChange,
	groupConvertToSimpleData
} from './handleQuestionChange';
import {
	partnerHandler,
	generalHandler
} from './sectionHandlers/index';
import { cloneDeep, isEmpty } from 'lodash';
import { useGenerateCCGASync } from 'services/QuoteService';
import { useSendStamp } from 'services/StampService';
import { useVerifyRiskAcceptanceAsync } from 'services/RiskAcceptanceService';

export default function CCGClauses({ permissions, ...props }) {
	const authContext = useContext(GlobalAuthContext);
	const [partners, setPartners] = useState([]);
	const [partnerDetails, setPartnerDetails] = useState([]);
	const [questionnaireAnswersToDelete, setQuestionnaireAnswersToDelete] = useState([]);
	const [hasPermission, setHasPermission] = useState(false);
	const [isAwaitingAnalysis, setIsAwaitingAnalysis] = useState(false);
	const { updateIsLoadingStatus } = useContext(LoaderContext);
	const validationSchema = useRef(yup.object().shape({}));
	const history = useHistory();
	const mc = new MessageCenter();
	const formikRef = useRef();
	const sharedCCG = useRef(false);
	const idOperationCCGProvider = useRef(null);
	const [operation, setOperation] = useState({});
	const [isBound, setIsBound] = useState(true);
	const handleBack = () => history.goBack();
	const [selectedClauses, setSelectedClauses] = useState([]);
	const [clausesLoading, setClausesLoading] = useState(false);
	const [reloadClauses, setReloadClauses] = useState(false);
	const getQuestionnaire = useRef(false);
	const [questionnaire, setQuestionnaire] = useState([]);
	const [documents, setDocuments] = useState([]);
	const [idProductPlan, setIdProductPlan] = useState(0);
	const [isInAnalysis, setIsInAnalysis] = useState(false);
	const [isSPE, setIsSPE] = useState(false);
	const recalculateParameters = useRef([]);
	const [changeValueClause, setChangeValueClause] = useState(false);
	const [changeLengthClauseInitial, setChangeLengthClauseInitial] = useState(0);
	const [onlyUpdateQuestionnaire, setOnlyUpdateQuestionnaire] = useState(false);

	const lockAndSave = questionnaire.find(
		qst => qst.idQuestion === 2015
	)?.idAnswerOption === 7689;

	const columnsPartners = [
		{
			title: "Seleção",
			key: "selected",
			minWidth: 5,
			maxWidth: 10
		},
		{
			title: "CPF/CNPJ",
			key: "documentId",
			minWidth: 10,
			maxWidth: 20
		},
		{
			title: "Nome Completo/Razão Social",
			key: "name",
			minWidth: 10,
			maxWidth: 40,
		},
		{
			title: "Email",
			key: "email",
			minWidth: 10,
			maxWidth: 40,
			notLastColumnAlign: true
		}
	];

	const SECTIONS = {
		CCG_DATA: { name: 'CCG_DATA', isMultiple: false, isRisk: false },
		PARTNER: { name: 'PARTNER', isMultiple: true, isRisk: false },
		CREDIT_ANALYSIS_INFO: { name: 'CREDIT_ANALYSIS_INFO', isMultiple: false, isRisk: false },
		LEGAL_REPRESENTATIVE: { name: 'LEGAL_REPRESENTATIVE', isMultiple: false, isRisk: false }
	};

	const {
		loading: useGetDocumentsAsyncLoading,
		request: useGetDocumentsAsyncRequest
	} = useGetDocumentsAsync(props.match.params.idOperation);

	const {
		loading: useVerifyRiskAcceptanceLoading,
		request: useVerifyRiskAcceptanceRequest
	} = useVerifyRiskAcceptanceAsync(props.match.params.idOperation);

	const {
		loading: useUpdateOperationLoading,
		request: useUpdateOperationRequest
	} = useUpdateOperationSync(props.match.params.idOperation);

	const {
		data: useResetOperationStateData,
		loading: useResetOperationStateLoading,
		error: useResetOperationStateError,
		status: useResetOperationStateStatus,
		request: useResetOperationStateRequest,
	} = useResetOperationState(props.match.params.idOperation);

	const {
		loading: useGetOperationLoading,
		request: useGetOperationRequest
	} = useGetOperationAsync(props.match.params.idOperation);

	const {
		data: useGetQuestionnairesAnswersData,
		loading: useGetQuestionnairesAnswersLoading,
		error: useGetQuestionnairesAnswersError,
		status: useGetQuestionnairesAnswersStatus,
		request: useGetQuestionnairesAnswersRequest,
	} = useGetQuestionnaireAnswer(props.match.params.idOperation);

	const {
		request: useGetSerasaStatusPartnerAsyncRequest,
		loading: useGetSerasaStatusPartnerAsyncLoading,
	} = useGetSerasaStatusPartnerAsync();

	const {
		loading: useUpdateDocumentsClausesLoading,
		request: useUpdateDocumentsClausesRequest,
	} = useUpdateDocumentsClausesSync(props.match.params.idOperation);

	const {
		data: useSaveQuestionnaireAnswerData,
		loading: useSaveQuestionnaireAnswerLoading,
		error: useSaveQuestionnaireAnswerError,
		status: useSaveQuestionnaireAnswerStatus,
		request: useSaveQuestionnaireAnswerRequest,
	} = useSaveQuestionnaireAnswer(props?.match?.params?.idOperation);

	const {
		data: useGenerateCCGData,
		loading: useGenerateCCGLoading,
		error: useGenerateCCGError,
		status: useGenerateCCGStatus,
		request: useGenerateCCGRequest
	} = useGenerateCCGASync(props.match?.params?.idOperation);

	const {
		loading: useSendStampLoading,
		status: useSendStampStatus,
		request: useSendStampRequest,
	} = useSendStamp(props?.match?.params?.idOperation);

	const {
		request: useGetQuestionnaireAnswerAsyncRequest,
		loading: useGetQuestionnaireAnswerAsyncLoading,
	} = useGetQuestionnaireAnswerAsync(idOperationCCGProvider.current);

	useEffect(() => {
		updateIsLoadingStatus(
			useGetDocumentsAsyncLoading ||
			useGetOperationLoading ||
			useResetOperationStateLoading ||
			useGetQuestionnairesAnswersLoading ||
			useUpdateDocumentsClausesLoading ||
			useUpdateOperationLoading ||
			useSaveQuestionnaireAnswerLoading ||
			clausesLoading ||
			useGenerateCCGLoading ||
			useSendStampLoading ||
			useVerifyRiskAcceptanceLoading ||
			useGetQuestionnaireAnswerAsyncLoading ||
			useGetSerasaStatusPartnerAsyncLoading
		)
	}, [
		useGetDocumentsAsyncLoading,
		useGetOperationLoading,
		useResetOperationStateLoading,
		useGetQuestionnairesAnswersLoading,
		useUpdateDocumentsClausesLoading,
		useUpdateOperationLoading,
		useSaveQuestionnaireAnswerLoading,
		clausesLoading,
		useGenerateCCGLoading,
		useSendStampLoading,
		useVerifyRiskAcceptanceLoading,
		useGetQuestionnaireAnswerAsyncLoading,
		useGetSerasaStatusPartnerAsyncLoading
	]);

	useEffect(() => {
		if (selectedClauses && changeLengthClauseInitial != selectedClauses.length) {
			let lengthMax = selectedClauses.length <= changeLengthClauseInitial ? changeLengthClauseInitial : selectedClauses.length;
			if (changeLengthClauseInitial == 0) {
				setChangeLengthClauseInitial(lengthMax)
			}
		}
	}, [selectedClauses]);

	useEffect(() => {
		if (useGetQuestionnairesAnswersStatus === 200) {
			useVerifyRiskAcceptanceRequest({ draft: true }).then(({ data }) => {
				const { riskDescription } = data?.value;
				setIsInAnalysis(riskDescription === 'Analisar');
				handleQuestionnaire(useGetQuestionnairesAnswersData?.value, riskDescription === 'Analisar')
			})
		}
	}, [useGetQuestionnairesAnswersStatus]);

	useEffect(() => {
		if (getQuestionnaire.current) return;
		if (isEmpty(permissions)) return;
		getQuestionnaire.current = true

		if (props.match.params.idOperation) {
			useGetOperationRequest(null, { loadLastDocument: true, loadOperationPersonRoles: true }).then(async (response) => {
				let operationData;
				if (response.status === 200) {
					operationData = response.data?.value;
					setOperation(operationData);
					setIsAwaitingAnalysis(operationData?.idDomainStatus === 419)
					setIsBound([5, 419, 6, 133, 158, 187, 263, 104, 99, 159, 140, 177, 188, 198, 176, 403].includes(operationData?.idDomainStatus))
					await handleGetCCGDocuments()
				}

				useGetQuestionnairesAnswersRequest(null)
			});
		}
	}, [permissions]);

	useEffect(() => {
		onlyUpdateQuestionnaire && onSave(formikRef.current.values);
	}, [onlyUpdateQuestionnaire]);

	useEffect(() => {
		setHasPermission(!((operation?.idOperation && !permissions.EDIT_CREDIT_ANALYSIS) || (!operation?.idOperation && !permissions.CREATE_CREDIT_ANALYSIS)));

		// setQuestionnaire(questionnaire)
	}, [questionnaire, permissions]);

	useEffect(() => {
		if (useGetQuestionnairesAnswersStatus === 200) {
			let questionnaire = [];
			questionnaire = [
				...useGetQuestionnairesAnswersData?.value.persons,
				...useGetQuestionnairesAnswersData?.value.operations,
				...useGetQuestionnairesAnswersData?.value.payments,
				...useGetQuestionnairesAnswersData?.value.risks
			];

			setQuestionnaire(questionnaire.map(qst => {
				if (qst.idQuestion === 1202 || qst.idQuestion === 1203) {
					if (!qst.answer) qst.visibleQuestion = false;
					qst.behaviorObject.paddingRight = 0;
				} else if (qst.idQuestion === 1427) {
					qst.visibleQuestion = false;
				}
				return qst;
			}));
		}
	}, [useGetQuestionnairesAnswersStatus]);

	const updateClausesAsync = async () => {
		setChangeLengthClauseInitial(0);
		useUpdateDocumentsClausesRequest({ selectedClauses: [] }, { idDomainDocument: 689 }).then((response) => {
			if (response.status === 200) {
				setOnlyUpdateQuestionnaire(false);
				setReloadClauses(true);
			}
		});
	};

	useEffect(() => {
		const generateCcg = async () => {
			if (useSaveQuestionnaireAnswerStatus === 200) {
				useGetQuestionnairesAnswersRequest(null);
				await handleGetCCGDocuments();

				const partnersSign = partners.map((partner, index) => ({
					selected: partnerDetails[index].selected,
					documentId: partner.find(qst => qst.idQuestion === 1654).answer,
					name: partner.find(qst => qst.idQuestion === 1655).answer,
					email: partner.find(qst => qst.idQuestion === 1780).answer,
					entryDate: ""
				})).filter(partner => partner.selected) || [];

				if (!documents.length) {
					await useGenerateCCGRequest({ idProductPlanSelected: idProductPlan, partners: partnersSign });
				}
				await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 689 });
				await useResetOperationStateRequest({ idDomainOrigin: 689 });
				await useGenerateCCGRequest({ idDomainStatus: 438, idProductPlanSelected: idProductPlan, partners: partnersSign });
				history.push(`/credit-analysis/ccg/${props.match.params.idProduct}/${props.match.params.idOperation}`);
			}

			if (useSaveQuestionnaireAnswerStatus === 400) {
				useSaveQuestionnaireAnswerError.errors?.map(error => {
					if (error.message) mc.error(error.message)
				})
			}
		}

		if (!onlyUpdateQuestionnaire) {
			sharedCCG.current
				? handleLimitProvider()
				: generateCcg();
		}
		if (useSaveQuestionnaireAnswerStatus === 200 && onlyUpdateQuestionnaire) {
			useGetQuestionnairesAnswersRequest(null);

			if (!documents.length) {
				setOnlyUpdateQuestionnaire(false);
				setReloadClauses(true);
				return
			}
			updateClausesAsync();
		}

	}, [useSaveQuestionnaireAnswerStatus]);

	useEffect(() => {
		buildValidation()
	}, [questionnaire, partners]);

	useEffect(() => {
		if (!clausesLoading) setReloadClauses(null)
	}, [clausesLoading]);

	const handleGetCCGDocuments = async () => {
		const { data: { value: documentsData } } = await useGetDocumentsAsyncRequest(null, { idDomain: 689 });
		setDocuments(documentsData.map(document => ({
			idDocument: document.idDocument,
			idDomainDescription: document.idDomainDescription,
			idReport: document.idReport,
			idOperation: document.idOperation,
			reportToken: document.reportToken,
			url: document.url,
			fileName: document.documentMetadata.fileName,
			documentMetadata: document.documentMetadata
		})));
	}

	const handleLimitProvider = async () => {
		console.log("sharedCCG status", sharedCCG, operation);
		//ToDo validar status da operacao de credito para finalizada
		history.push("/credit-analysis");
	}

	const handleQuestionnaire = async (data, isInAnalysis) => {
		let questionnaire = [];
        setPartners([])
        setQuestionnaire(questionnaire);

        await new Promise(resolve => setTimeout(() => resolve(), 500))

		questionnaire = [
			...data.persons,
			...data.operations,
			...data.payments,
			...data.risks
		];

		questionnaire = handleQuestionsInitialAdjustments(
			questionnaire,
			operation,
			setIdProductPlan,
			isInAnalysis,
			formikRef?.current?.setFieldValue,
			sharedCCG,
			permissions,
			authContext
		);
		questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);
		const isSPE = questionnaire.find(qst => qst.idQuestion === 1723)?.idAnswerOption === 7336;


		setIsSPE(isSPE);
		const dataPartnerTableInfo = groupConvertToSimpleData(1654, questionnaire, operation, isBound);
		const partnerQuestions = generalHandler.events.groupMultipleFieldQuestions({
			mainIdQuestion: 1654,
			questionnaire,
			handleQuestionsInitialAdjustments: partnerHandler.events.handleInitialAdjustments,
			permissions
		});

		setPartnerDetails(dataPartnerTableInfo);
		setPartners(partnerQuestions);
		setQuestionnaire(questionnaire);
	}

	const handleSaveQuestionnaireAnswer = (idOperation, onlyQuestions, formattedGroups) => {
		let questionnaireAnswers = cloneDeep(questionnaire);
		for (const [key, section] of Object.entries(SECTIONS)) {
			if (section.isMultiple) {
				let multipleFields = []
				switch (section.name) {
					case 'PARTNER':
						multipleFields = cloneDeep(partners);
						break;
					default:
						multipleFields = [];
						break;
				}

				// QUEBRANDO O CODIGO
				multipleFields.map(group => {
					if (group?.length) {
						const rootQuestion = group.find(question => !question.idQuestionRoot);
						const childrenQuestions = group.filter(question => question.idQuestionRoot);
						rootQuestion.childrenQuestions = childrenQuestions;
						if (!onlyQuestions || formattedGroups) {
							questionnaireAnswers = [...questionnaireAnswers, rootQuestion];
						} else {
							questionnaireAnswers = [...questionnaireAnswers, ...group];
						}
					}
				})
			}
		}

		let childrenQuestionIds = [];
		for (const question of questionnaireAnswers) {
			if (question) {
				if (
					(
						question.idDomainQuestion === 270 ||
						question.idDomainQuestion === 271 ||
						(question.idDomainQuestion === 44 && typeof question.answer === 'object')
					) && question.answer
				) {
					try {
						question.answer = JSON.stringify(question.answer)
					} catch (e) {
					}
				}

				if (SECTIONS[question.behaviorObject?.sectionName] && SECTIONS[question.behaviorObject?.sectionName].isMultiple) {
					if (question?.childrenQuestions?.length) {
						const idQuestions = question.childrenQuestions.map(question => question.idQuestion);
						childrenQuestionIds = [...childrenQuestionIds, ...idQuestions];
					}
				} else {
					question.childrenQuestions = [];
				}
				// if (
				//     currentModality &&
				//     question.productPlans?.length &&
				//     !question.productPlans.includes(currentModality) &&
				//     (question?.answer != null || question?.idAnswerOption)
				// ) {
				//     question.answer = null;
				//     question.idAnswerOption = null;
				// }
			}
		}

		questionnaireAnswers = questionnaireAnswers.filter(v => !childrenQuestionIds.includes(v.idQuestion) && ![1727, 1728].includes(v.idQuestion))
			.filter(v =>
				v.behaviorObject?.sectionName === 'CCG_DATA' ||
				v.behaviorObject?.sectionName === 'PARTNER' ||
				v.behaviorObject?.sectionName === 'LEGAL_REPRESENTATIVE' ||
				v.idQuestion === 1813
			);

		if (onlyQuestions) return questionnaireAnswers;

		if (idOperation) useSaveQuestionnaireAnswerRequest(questionnaireAnswers);
	}

	const buildValidation = (draft) => {
		const validationSchema = {};
		const questionnaire = handleSaveQuestionnaireAnswer(props.match.params.idOperation, true);

		let allQuestions = [...questionnaire];

		for (const question of allQuestions) {
			if (question.childrenQuestions?.length) allQuestions = [...allQuestions, ...question.childrenQuestions]
		}

		const field1654Validation = allQuestions
			.filter(question => question.visibleQuestion && question.idQuestion === 1654)
			.map(question => question.answer)
			.sort((a, b) => a - b);
		const field1713Validation = allQuestions
			.filter(question => question.visibleQuestion && question.idQuestion === 1713)
			.map(question => question.answer)
			.sort((a, b) => a - b);

		for (const question of allQuestions) {
			if (draft && ![658, 660, 688, 1225, 1226].includes(question.idQuestion)) continue;
			if ([614].includes(question?.idDomainQuestion)) continue;
			if (!question?.key || question?.behaviorObject.sectionName === "INSURED") continue;

			if (question.visibleQuestion && question.behaviorObject?.isRequired && question.fieldMask?.type == 'phone') {
				validationSchema[question.key] = yup.string().test({
					name: "answer-validation",
					message: "Telefone inválido",
					test: (value) => !!value && value.length >= 10
				})
			} else if (question.visibleQuestion && question.behaviorObject?.fieldMask == 'email') {
				if (question.answer) {
					validationSchema[question.key] = yup.string().email("E-mail inválido").required("Campo obrigatório")
				} else {
					if (question.behaviorObject?.isRequired) {
						validationSchema[question.key] = yup.string().email("E-mail inválido").required("Campo obrigatório")
					} else {
						validationSchema[question.key] = yup.string().notRequired();
					}
				}
			} else if (
				question.idQuestion === 1654 &&
				question.answer &&
				question.visibleQuestion &&
				question.behaviorObject?.isRequired &&
				field1654Validation.length > 1
			) {
				validationSchema[question.key] = yup.string().test(
					"answer-validation",
					"CPFCNPJ",
					() => {
						const uniquefields = Array.from(new Set(field1654Validation)).sort((a, b) => a - b);
						return uniquefields.length === field1654Validation.length && uniquefields.every((value, index) => value === field1654Validation[index] && value !== '');
					}
				);
			} else if (
				question.idQuestion === 1713 &&
				question.answer &&
				question.visibleQuestion &&
				question.behaviorObject?.isRequired &&
				field1713Validation.length > 1
			) {
				validationSchema[question.key] = yup.string().test(
					"answer-validation",
					"CPFCNPJ",
					() => {
						const uniquefields = Array.from(new Set(field1713Validation)).sort((a, b) => a - b);
						return uniquefields.length === field1713Validation.length && uniquefields.every((value, index) => value === field1713Validation[index]);
					}
				);
			} else {
				validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired ?
					yup.string().test("answer-validation", "Campo obrigatório", function (value) {
						return !!question.answer;
					}) : yup.string().notRequired();
			}
		}

		return yup.object().shape(validationSchema);
	}

	const onSave = async (values, idDomainStatus, draft) => {
		buildValidation(draft).validate(values, { abortEarly: false })
			.then(() => {
				handleSubmit(values, idDomainStatus)
			})
			.catch((e) => {
				setQuestionnaire(questionnaire.map(qst => {
					if (qst.idQuestion === 2015) {
						//option switch off
						const answerOpt = qst.answerOptions.find(q => q.idAnswerOption === 7688);

						qst.answer = answerOpt.dsAnswerOption;
						qst.idAnswerOption = answerOpt.idAnswerOption;

						formikRef?.current?.setFieldValue && formikRef.current.setFieldValue(qst.key, qst.answer)
					}
					return qst;
				}));
				setOnlyUpdateQuestionnaire(false);
				generalHandler.events.onValidationError(
					e,
					mc,
					formikRef,
					questionnaire,
					[...partners]
				);
			})
	}

	const handleSubmit = async (values, idDomainStatus) => {
		handleSaveQuestionnaireAnswer(props.match.params.idOperation);
	}

	const handleResetDocumentClauses = async (question, value) => {
		if (!documents.length) {
			const answerOption = question.answerOptions.find(v => v.idAnswerOption === value?.idAnswerOption);
			setIdProductPlan(answerOption.behaviorObject.resultProductPlan);
		} else {
			const responseReset = await useUpdateDocumentsClausesRequest({ selectedClauses: [] }, { idDomainDocument: 689 });

			if (responseReset && responseReset.status === 200) {
				let answerOption = question.answerOptions.find(v => v.idAnswerOption === value?.idAnswerOption);

				setIdProductPlan(answerOption.behaviorObject.resultProductPlan);
			}
		}
	}

	return (
		<Layout
			title={"Gerar CCG"}
			subtitle={`${operation?.productName || ""}`}
		>
			<StepNavigation
				stage={2}
				idOperation={props?.match?.params?.idOperation}
				permissions={permissions}
			/>

			<BrokingSummary
				idProduct={props?.match?.params?.idProduct}
				idOperation={props?.match?.params?.idOperation}
				history={history}
				permissions={permissions}
			/>

			<Content>
				<Formik
					innerRef={formikRef}
					initialValues={{}}
					validateOnChange={false}
					validateOnBlur={false}
					enableReinitialize={true}
				>
					{({ values, errors, setFieldValue, setFieldError }) => {

						return (
							<Form onKeyDown={(e) => {
								if (e.key === 'Enter') e.preventDefault();
							}}>
								<FormContainer title="DADOS CCG">
									{<FormSection
										setQuestionnaire={setQuestionnaire}
										sectionName="CCG_DATA"
										disableAll={isBound}
										idProduct={props.match.params.idProduct}
										operation={operation}
										values={values}
										errors={errors}
										setFieldValue={setFieldValue}
										setFieldError={setFieldError}
										questionnaire={questionnaire}
										permissions={permissions}
										ignoreModality
										formikRef={formikRef}
										onQuestionChange={(
											question,
											value,
											setFieldValue,
											questionnaireUpdated
										) => handleQuestionChange(
											question,
											value,
											questionnaireUpdated,
											setQuestionnaire,
											setFieldValue,
											setChangeLengthClauseInitial,
											handleResetDocumentClauses,
											sharedCCG,
											operation,
											setPartners,
											setOnlyUpdateQuestionnaire
										)}
									/>
									}


									<table style={{
										borderCollapse: 'separate',
										tableLayout: 'fixed',
									}}>
										<tbody>
											{partners.map((questions, index) => (
												<>
													<HasPermission permission={!index}>
														<div>
															<tr>
																<td style={{ minWidth: '100px', maxWidth: '100px' }}>
																	<Label>SELEÇÃO</Label>
																</td>
																<td style={{ minWidth: '290px', maxWidth: '290px' }}>
																	<Label>CPF/CNPJ</Label>
																</td>
																<td style={{ minWidth: '400px', maxWidth: '400px' }}>
																	<Label>NOME COMPLETO/RAZÃO SOCIAL</Label>
																</td>
																<td>
																	<Label>EMAIL</Label>
																</td>
															</tr>
														</div>
													</HasPermission>

													<FormContainer
														noTitlePadding
														title={questions.find(v => v.idQuestion === 1787)?.answer || ''}
														noTitle={!partnerDetails[index].selected}
														collapsedAtStart={true}
														customHeader={
															<tr>
																<td style={{ minWidth: '100px', maxWidth: '100px' }}>
																	<CheckBox
																		disabled={
																			lockAndSave ||
																			!(permissions.FORMALIZE_CREDIT_ANALYSIS ||
																				permissions.ANALYZE_CREDIT_ANALYSIS_SAVE)
																		}
																		checked={questions.find(qst => qst.idQuestion === 2040)?.idAnswerOption === 7695}
																		onClick={() => {
																			if (lockAndSave ||
																				!(permissions.FORMALIZE_CREDIT_ANALYSIS ||
																					permissions.ANALYZE_CREDIT_ANALYSIS_SAVE)
																			) return;

																			const partnerSelected = questions.find(qst => qst.idQuestion === 2040);
																			const answerOpt = partnerSelected.answerOptions.find(
																				qst => qst.idAnswerOption === (partnerSelected.idAnswerOption === 7695 ? 7694 : 7695)
																			);

																			setPartners(partners.map((partner, i) => {
																				if (i === index) {
																					const maritalStatus = partner.find(
																						qst => qst.idQuestion === 1660
																					)?.idAnswerOption;

																					partner.map(qst => {
																						if (qst.idQuestion === 2040) {
																							qst.answer = answerOpt.dsAnswerOption;
																							qst.idAnswerOption = answerOpt.idAnswerOption;
																							return qst;
																						}
																						qst.visibleQuestion = answerOpt.idAnswerOption === 7695;
																						if ([1713, 1714, 1737, 1799, 1800].includes(qst.idQuestion)) {
																							qst.visibleQuestion = [7253, 7257].includes(maritalStatus) && answerOpt.idAnswerOption === 7695;
																						}
																						return qst;
																					});
																				}
																				return partner;
																			}));

																			setPartnerDetails((previous) => previous.map(ptnr => {
																				if (ptnr.documentId === partnerDetails[index].documentId) {
																					ptnr.selected = answerOpt.idAnswerOption === 7695;
																				}
																				return ptnr;
																			}));
																		}}
																	/>
																</td>
																<td style={{ minWidth: '290px', maxWidth: '290px' }}>
																	<Label>{values[questions.find(qst => qst.idQuestion === 1654)?.key]}</Label>
																</td>
																<td style={{ minWidth: '400px', maxWidth: '400px' }}>
																	<Label>{values[questions.find(qst => qst.idQuestion === 1655)?.key]}</Label>
																</td>
																<td>
																	<Label>{values[questions.find(qst => qst.idQuestion === 1780)?.key]}</Label>
																</td>
															</tr>
														}
													>
														<FormSection
															setQuestionnaire={(questionnaire) => setPartners(partners.map((v, i) => i === index ? questionnaire : v))}
															sectionName="PARTNER"
															sectionIndex={index}
															disableAll={questionnaire.find(qst => qst.idQuestion === 2015)?.idAnswerOption === 7689}
															showWarning={isAwaitingAnalysis}
															idProduct={props.match.params.idProduct}
															values={values}
															errors={errors}
															setFieldValue={setFieldValue}
															setFieldError={setFieldError}
															formikRef={formikRef}
															questionnaire={questions}
															ignoreModality
															onSearchZipCode={(zipCodeData, setFieldValue, rootQuestion) => partnerHandler.events.handleSearchZipCode({
																rootQuestion,
																zipCodeData,
																questionnaire: questions,
																setQuestionnaire: (questionnaire) => setPartners(partners.map((v, i) => i === index ? questionnaire : v)),
																setFieldValue
															})}
															onQuestionChange={(
																question,
																value,
																setFieldValue,
																questionnaireUpdated
															) => {
																partnerHandler.events.handleQuestionChange({
																	question,
																	value,
																	questionnaireUpdated,
																	setQuestionnaire: (questionnaire) => setPartners(partners.map((v, i) => i === index ? questionnaire : v)),
																	setFieldValue,
																})
															}}
															extraButtonsQuestion={(question) => {
																if (question.idQuestion !== 1661) return null
																return (
																	<RefreshButon type="button" onClick={() => useGetSerasaStatusPartnerAsyncRequest({ cpfCnpj: questions.find((v) => v.idQuestion === 1654).answer }, { draft: true })
																		.then(({ data }) => {
																			if (!data.ret_value) return;

																			partnerHandler.events.handleQuestionChange({
																				question,
																				value: data?.ret_value,
																				questionnaireUpdated: questions,
																				setQuestionnaire: (questionnaire) => setPartners(partners.map((v, i) => i === index ? questionnaire : v)),
																				setFieldValue,
																			});
																		})}>
																		<Icon name='generate' title='Consultar Score Serasa' />
																	</RefreshButon>
																)
															}}
															permissions={permissions}
														/>
													</FormContainer>

												</>
											))}
											<FormContainer
												noTitlePadding
												collapsedAtStart={true}
												customHeader={
													<tr>
														<td style={{ minWidth: '100px', maxWidth: '100px' }}>
															<CheckBox
																disabled={true}
																checked={true}
																onClick={() => { }}
															/>
														</td>
														<td style={{ minWidth: '290px', maxWidth: '290px' }}>
															<Label>{questionnaire.find(qst => qst.idQuestion === 1634)?.answer || ''}</Label>
														</td>
														<td style={{ minWidth: '400px', maxWidth: '400px' }}>
															<Label>{questionnaire.find(qst => qst.idQuestion === 1635)?.answer || ''}</Label>
														</td>
														<td>
															<Label>{questionnaire.find(qst => qst.idQuestion === 1807)?.answer || ''}</Label>
														</td>
													</tr>
												}
											>
												<FormSection
													setQuestionnaire={setQuestionnaire}
													sectionName="LEGAL_REPRESENTATIVE"
													disableAll={questionnaire.find(qst => qst.idQuestion === 2015)?.idAnswerOption === 7689}
													showWarning={isAwaitingAnalysis}
													idProduct={props.match.params.idProduct}
													values={values}
													errors={errors}
													setFieldValue={setFieldValue}
													setFieldError={setFieldError}
													formikRef={formikRef}
													questionnaire={questionnaire}
													ignoreModality
													permissions={permissions}
												/>
											</FormContainer>
										</tbody>
									</table>
								</FormContainer>


								<div style={{ display: lockAndSave ? "block" : "none" }}>
									{partners.length && idProductPlan ? <Clauses
										idOperation={props.match.params.idOperation}
										idProduct={props.match.params.idProduct}
										idProductPlan={idProductPlan}
										isInAnalysis={isInAnalysis}
										permission={permissions.MANUAL_SIGNATURE}
										idDomainDocument={689}
										isLoading={(isLoading) => setClausesLoading(isLoading)}
										onSelectClauses={(onSelectClauses) => {
											setSelectedClauses(onSelectClauses)
										}}
										changeValueClause={(changeValueClause) => setChangeValueClause(changeValueClause)}
										reloadClauses={reloadClauses}
										overwriteQstValues={{
											partners: partners.map((partner, index) => ({
												selected: partnerDetails[index].selected,
												documentId: partner.find(qst => qst.idQuestion === 1654).answer,
												name: partner.find(qst => qst.idQuestion === 1655).answer,
												email: partner.find(qst => qst.idQuestion === 1780).answer,
												entryDate: ""
											}))
										}}
									/> : null}
								</div>

								<ButtonContainer style={{ padding: '0 10px' }}>
									<Button forth style={{ width: 'auto' }} onClick={() => handleBack()}> &lt; VOLTAR </Button>
									<ButtonContent>
										<HasPermission permission={operation?.idOperation && permissions.REJECT_CCG}>
											<LostCancelButton idQuestion={1725} idOperation={props.match?.params?.idOperation}
												title={'RECUSAR'} />
										</HasPermission>
										<HasPermission permission={!isBound && permissions.GENERATE_CREDIT_ANALYSIS && lockAndSave}>
											<Button
												id="btnContinue"
												type="submit"
												onClick={async (e) => {
													if (changeValueClause || (changeLengthClauseInitial != selectedClauses.length)) {
														await handleClauseQuestionChange(questionnaire, setQuestionnaire, setFieldValue);
													}
													e.preventDefault();
													e.stopPropagation();
													onSave(values, null, undefined)
												}}
												style={{ marginLeft: 15 }}
												primary
											>
												{!sharedCCG.current ? "GERAR CCG" : "SALVAR"}
											</Button>
										</HasPermission>
										<HasPermission permission={!isBound && permissions.CREATE_ENQUIRY && operation?.operationMetadata?.envelopeExternalId && lockAndSave}>
											<Button
												id="btnCreateQuote"
												type="button"
												onClick={() => history.push("/list")}
												style={{ marginLeft: 15 }}
												primary
											>
												CRIAR COTAÇÃO
											</Button>
										</HasPermission>
									</ButtonContent>
								</ButtonContainer>
							</Form>
						)
					}}
				</Formik>
			</Content>
		</Layout>
	)
}
